export default __webpack_public_path__ + "static/media/goopter-disinfection-robot-sterilization-modes.aaa29a04.jpg";